import { render, staticRenderFns } from "./datosAdicionales.vue?vue&type=template&id=e787789e&scoped=true"
import script from "./datosAdicionales.vue?vue&type=script&lang=js"
export * from "./datosAdicionales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e787789e",
  null
  
)

export default component.exports